// extracted by mini-css-extract-plugin
export default {"noImage":"M2Zb4VyDmzX4qzGkkr5o"};